




































import { Vue, Component, Inject, Prop } from "vue-property-decorator";
import {
  IAffiliatePayoutDestinationsProvider,
  IAffiliatePayoutDestinationsMethods
} from "@/models/providers/affiliatePayoutDestinations";
import { IClient } from "@/models/clients";
import { IAccount } from "@/models/accounts";
import { DataModules } from "@/store/modules/data";

@Component({
  components: {
    "payout-destination-select": () =>
      import("@/components/app/global/affiliate/payoutDestinationSelect.vue"),
    "client-email-select": () =>
      import("@/components/app/global/fields/clientEmailSelect.vue")
  }
})
export default class ClientAffiliatePayoutDestination extends Vue {
  // Inject

  @Inject({ from: "affiliatePayoutDestinationsProvider" })
  public affiliatePayoutDestinationsProvider!: () => IAffiliatePayoutDestinationsProvider;

  @Inject({ from: "affiliatePayoutDestinationsProviderMethods" })
  public $affPDsMethods!: IAffiliatePayoutDestinationsMethods;

  @Prop({ required: true })
  public clientId!: IClient["id"];

  @Prop({ required: true })
  public accountId!: IAccount["id"];

  @Prop({ required: true })
  public payoutDestinationId!: IAccount["affiliate_payout_destination_id"];

  @Prop({ required: true })
  public paypalEmailId!: IAccount["affiliate_payout_paypal_email_id"];

  // Data

  public form = this.initForm();
  public isProcessing = false;

  // Computed

  public get isPayPal() {
    return this.$affPDsMethods.isPaypal(
      this.form.affiliate_payout_destination_id
    );
  }

  public get $affPDData() {
    return this.affiliatePayoutDestinationsProvider();
  }

  public get isFormChanged() {
    return !this.$_.isEqual(this.form, this.initForm());
  }

  // Methods
  public initForm() {
    return {
      affiliate_payout_destination_id: this.payoutDestinationId,
      affiliate_payout_paypal_email_id: this.paypalEmailId
    };
  }

  public revertToInitialState() {
    this.form = this.initForm();
  }

  public updateClientAccount() {
    return this.$store.dispatch(`data/${DataModules.CLIENTS_ACCOUNTS}/update`, {
      accountId: this.accountId,
      data: this.form
    });
  }

  public async save() {
    try {
      this.isProcessing = true;
      await this.updateClientAccount();
      this.$emit("success");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }
}
